import { createTheme } from '@mui/material/styles'

const theme = createTheme({
  // color
  palette: {
    primary: {
      main: '#515151',
    },
    secondary: {
      main: '#707070',
    },
  }, 

  // font 
  typography: {
    h2: {
      fontFamily: 'GenYOGothic2TW',
      fontWeight: 'bold',
      fontSize: '2.5rem',
      lineHeight: '4rem',
      color: '#515151',
      marginBottom: '1rem'
    },
    h3: {
      fontFamily: 'GenYOGothic2TW',
      fontWeight: 'bold',
      fontSize: '2rem',
      lineHeight: '3.2rem',
      color: '#515151',
      marginBottom: '1rem'

    },
    h4: {
      fontFamily: 'GenYOGothic2TW',
      fontWeight: 'bold',
      fontSize: '1.5rem',
      lineHeight: '2rem',
      color: '#515151',
    },
    h5: {
      fontFamily: 'GenYOGothic2TW',
      fontWeight: 'bold',
      fontSize: '1.5rem',
      lineHeight: '2rem',
      color: '#515151',
    },
    subtitle1: {
      fontFamily: 'GenYOGothic2TW',
      fontWeight: 'normal',
      fontSize: '1.25rem',
      lineHeight: '2rem',
      color: '#515151'
    },
    body1: {
      fontFamily: 'GenYOGothic2TW',
      fontWeight: 'normal',
      fontSize: '1rem',
      color: '#515151',
      lineHeight: '1.5rem'
    },
  },

  // breakpoint
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 900,
      lg: 1280,
      xl: 1536,
    },
  },
})

export default theme